import React from 'react';
/** @jsx jsx */
import { jsx } from '@emotion/core';
import css from '@emotion/css/macro';

export default class TableBody extends React.Component {
  render() {
    return <div css={css`
      position: relative;
      flex: 1 1 0%;
    `}>{this.props.children}</div>
  }
}